<template>
  <div class="header_box_warp">
    <div class="header_box">
      <div class="header_r">
        <div class="text_box">
          <div class="green_box">
            <div class="wx_icon"><img class="img" :src="publicPath + 'icon_WeChat.png' + '?time=' + new Date().getTime()" /></div>
            官方微信
            <div class="ma_box"><img class="img" :src="publicPath + '81lp_ma.jpg' + '?time=' + new Date().getTime()" /></div>
          </div>
          <div class="span" @click="enterCompany()">企业入口</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {

    }
  },
  created() {
  },
  computed: {
    ...mapState(['publicPath','platformInfo'])
  },
  methods: {
    enterCompany() {
      if(this.platformInfo.env == 'test'){
        window.open("https://test-bsp.81lianpin.com/mana/home");
      }else{
        window.open("https://bsp.81lianpin.com/mana/home"); 
      }

    }
  }
}
</script>

<style scoped>
.header_box_warp {
  background: #000;
}
.header_box {
  width: 1200px;
  height: 30px;
  margin: 0 auto;
  color: #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header_r {
  position: relative;
}
.text_box {
  display: flex;
}
.green_box {
  display: flex;
  line-height: 15px;
  padding: 0 8px;
  cursor: pointer;
  color: #05e778;
  border-right: 1px solid #fff;
}
.wx_icon {
  width: 20px;
  height: 16px;
  margin-right: 8px;
}
.header_r .span {
  line-height: 15px;
  padding: 0 8px;
  cursor: pointer;
}
.green_box:hover .ma_box {
  display: block;
}
.ma_box {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 23px;
  left: 2px;
  display: none;
}
</style>








// WEBPACK FOOTER //
// src/components/HeaderTop2.vue